module.exports = __webpack_public_path__ + "img/onexox-logo.ddab27ce.png";